import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicAggregateGUI } from "src/model/class/component classes/generic-basic-aggregate-gui";
import { SupervisionComponentAPI } from "src/model/class/component classes/supervision-component-api";
import { GuiComponent } from "src/model/enum/enumCustomInterface";
import { AccessControlGatewaySubgroup } from "src/components/shared-components/enum/enumGateway";
import { MqttClientService } from "src/service/mqtt-client.service";

@Component({
    selector: "app-virtual-access-template",
    templateUrl: "./virtual-access-template.component.html",
    styleUrls: ["./virtual-access-template.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VirtualAccessTemplateComponent
  extends GenericBasicAggregateGUI
  implements OnInit, OnDestroy {
  public showNumericKeyPad: boolean = false;
  public keyPadComponent: SupervisionComponentAPI = null;

  constructor(_injector: Injector, private _mqtt: MqttClientService) {
    super(_injector);
  }

  ngOnInit() {
    this.loadKeypadTemplateComponent();
  }

  /**
   * Show/hide nested element keypad
   */
  public onClickOpenPopupKeypad(): void {
    this.showNumericKeyPad = !this.showNumericKeyPad;
  }

  /**
   * Event handler from auto closing keypad component reset timer
   */
  public onResetTimerKeypadElapsed(): void {
    this.showNumericKeyPad = false;
  }

  /**
   * Search keypad component in virtual access list aggregate
   */
  private loadKeypadTemplateComponent(): void {
    this.keyPadComponent = this.aggregate.listComponent.find(
      (component: SupervisionComponentAPI) =>
        component.code === GuiComponent.VIRTUAL_ACCESS
    );
  }
}
